module.exports = __webpack_public_path__ + "static/media/p3_img1.200130f5.png";